"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
require("rxjs/add/operator/switchMap");
var rows_change_event_1 = require("../../model/event/rows-change-event");
var rows_change_event_type_1 = require("../../model/event/rows-change-event-type");
var report_table_view_model_1 = require("../../model/report-table-view.model");
var row_option_1 = require("../../model/row-option");
var row_view_model_1 = require("../../model/row-view.model");
var table_row_type_1 = require("../../model/table-row-type");
var dataset_container_1 = require("../../service/dataset-container");
var view_event_service_1 = require("../../service/view-event.service");
var row_type_1 = require("../model/row-type");
var rowview_drag_and_drop_manager_1 = require("../service/rowview-drag-and-drop-manager");
var SisTabularReportRowComponent = /** @class */ (function () {
    function SisTabularReportRowComponent(applicationPropertiesService, datasetContainer, viewEventService) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.datasetContainer = datasetContainer;
        this.viewEventService = viewEventService;
        this._groupedPathItems = new Map();
        this._subscriptions = [];
    }
    SisTabularReportRowComponent_1 = SisTabularReportRowComponent;
    SisTabularReportRowComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.dataSetId) {
            this._subscriptions.push(this.datasetContainer.getGroupedCategoryPaths(this.dataSetId).subscribe(function (paths) {
                _this._groupedPathItems = paths;
                _this._allPaths = new Map();
                Array.from(paths.values()).forEach(function (groupPaths) {
                    groupPaths.forEach(function (path) { return _this._allPaths.set(path.id, path); });
                });
            }));
        }
    };
    SisTabularReportRowComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    Object.defineProperty(SisTabularReportRowComponent.prototype, "groupedPathItems", {
        get: function () {
            return this._groupedPathItems;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Specifies new row's element
     */
    SisTabularReportRowComponent.prototype.add = function (change, rowView) {
        if (rowView.isGoingToReplace) {
            rowView.element = new idm_reporting_service_client_js_1.RowCategoryBuilder(change.value).getElement();
            this.reportTableView.rows.cleanSelectedFlags();
            this.reportTableView.rows.cleanGoingToReplaceFlags();
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_CREATED, this.reportTableView.rows.getCollapsedExpandedOptions()
                .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo())));
            return;
        }
        // position where new row must be added.
        var index = rowView.getNewRow() ? rowView.getNewRow().index : undefined;
        // hide temporary row with NEW type
        this.hideNew(rowView);
        // create row and add to specified position, remove temporary(with type NEW) rows.
        var newRow = new row_view_model_1.RowView();
        newRow.element = new idm_reporting_service_client_js_1.RowCategoryBuilder(change.value).getElement();
        newRow.rowType = row_type_1.RowType.SPECIFIED;
        newRow.index = index;
        rowView.add(newRow);
        this.reportTableView.rows.removeByCondition(function (row) { return row.rowType === row_type_1.RowType.NEW; });
        // recalculate indexes
        this.reportTableView.rows.setIndexes();
        // setting indexes for just isCreated row to put appropriate classes in view
        this.reportTableView.rows.setCreatedRowIndexes(newRow.index);
        this.reportTableView.rows.cleanNewRowIndexes();
        // send event to add isCreated row in table view
        var prevIndex = this.reportTableView.rows.findPreviousVisibleElementIndex(newRow.index);
        var nextIndex = this.reportTableView.rows.findNextVisibleElementIndex(newRow.index);
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .add(newRow.index, new row_option_1.RowOption(table_row_type_1.TableRowType.CREATED, true))
            .add(prevIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.BEFORE_CREATED, true))
            .add(nextIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.AFTER_CREATED, true))
            .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_CREATED, options));
    };
    SisTabularReportRowComponent.prototype.openSelectionMenu = function (event, rowView) {
        event.stopPropagation();
        this.reportTableView.rows.cleanSelectedFlags();
        this.reportTableView.rows.cleanGoingToReplaceFlags();
        this.viewEventService.resetElementSelection();
        this.selectMenu.open();
    };
    SisTabularReportRowComponent.prototype.onSelectionPanelClose = function (rowView) {
        this.dispelNew(rowView);
        this.hideNew(rowView);
    };
    SisTabularReportRowComponent.prototype.select = function (rowView) {
        if (rowView.element != null) {
            var wasSelected = rowView.isSelected;
            this.reportTableView.rows.cleanSelectedFlags();
            this.reportTableView.rows.cleanGoingToReplaceFlags();
            this.reportTableView.rows.cleanExpandedFlags();
            this.reportTableView.rows.cleanCreatedRowIndexes();
            rowView.isGoingToReplace = wasSelected;
            rowView.isSelected = true;
            this.viewEventService.rowElementSelected(rowView, this._allPaths.get(rowView.element.categoryElementDto.categoryPathHolderId));
            if (rowView.isGoingToReplace) {
                this.replaceMenu.open();
            }
        }
    };
    SisTabularReportRowComponent.prototype.prepareNew = function (rowView) {
        rowView.prepareNew = true;
        // send event to highlight current row in table view
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .add(rowView.index, new row_option_1.RowOption(table_row_type_1.TableRowType.HIGHLIGHTED, true)).setRowsCount(this.reportTableView.rows.rowsCount)
            .setInfo(this.reportTableView.rows.getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_HIGHLIGHTED, options));
    };
    SisTabularReportRowComponent.prototype.dispelNew = function (rowView) {
        if (!this.selectMenu || !this.selectMenu.isPanelOpen()) {
            rowView.prepareNew = false;
            // send event to remove highlight row from table view
            var options = this.reportTableView.rows.getCollapsedExpandedOptions().setRowsCount(this.reportTableView.rows.rowsCount)
                .setInfo(this.reportTableView.rows.getRowsInfo());
            this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_UNHIGHLIGHTED, options));
        }
    };
    SisTabularReportRowComponent.prototype.showNew = function (rowView) {
        if (rowView.isRemoved || rowView.showNew) {
            return;
        }
        // create new row view
        var newRow = new row_view_model_1.RowView();
        newRow.rowType = row_type_1.RowType.NEW;
        // add isCreated new-row in current row
        rowView.showNew = true;
        rowView.collapsed = undefined;
        // remove expanded class from rowView's branch
        var item = rowView;
        while (item != null) {
            item.collapsed = undefined;
            item = item.parent;
        }
        rowView.add(newRow);
        // clean is going to replace flags
        this.reportTableView.rows.cleanGoingToReplaceFlags();
        // cleaning indexes for just isCreated row to put appropriate classes in view
        this.reportTableView.rows.cleanCreatedRowIndexes();
        // clean removed element
        this.reportTableView.rows.cleanRemovedElements();
        // recalculate indexes
        this.reportTableView.rows.setIndexes(newRow);
        // send event to show new row in table view
        var prevIndex = this.reportTableView.rows.findPreviousVisibleElementIndex(newRow.index);
        var nextIndex = this.reportTableView.rows.findNextVisibleElementIndex(newRow.index);
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .add(newRow.index, new row_option_1.RowOption(table_row_type_1.TableRowType.NEW, true))
            .add(prevIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.BEFORE_NEW, true))
            .add(nextIndex, new row_option_1.RowOption(table_row_type_1.TableRowType.AFTER_NEW, true))
            .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_ACTIVATED, options));
    };
    SisTabularReportRowComponent.prototype.hideNew = function (rowView) {
        if (this.selectMenu && !this.selectMenu.isPanelOpen()) {
            rowView.showNew = false;
            if (rowView.getNewRow()) {
                rowView.deActivateNewRow();
                // recalculate indexes
                this.reportTableView.rows.setIndexes();
                // send event to deactivate isActive row in table view
                var options = this.reportTableView.rows.getCollapsedExpandedOptions()
                    .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
                this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_DEACTIVATED, options));
            }
        }
    };
    SisTabularReportRowComponent.prototype.isRowBeforeNew = function (index) {
        return index === this.reportTableView.rows.beforeNewRowIndex;
    };
    SisTabularReportRowComponent.prototype.isRowAfterNew = function (index) {
        return index === this.reportTableView.rows.afterNewRowIndex;
    };
    SisTabularReportRowComponent.prototype.isJustCreatedRow = function (index) {
        return index === this.reportTableView.rows.justCreatedRowIndex;
    };
    SisTabularReportRowComponent.prototype.isRowAfterCreated = function (index) {
        return index === this.reportTableView.rows.afterCreatedRowIndex;
    };
    SisTabularReportRowComponent.prototype.isRowBeforeCreated = function (index) {
        return index === this.reportTableView.rows.beforeCreatedRowIndex;
    };
    SisTabularReportRowComponent.prototype.hasChildren = function (rowView) {
        return rowView.children.filter(function (value) { return !value.isRemoved; }).length > 0;
    };
    SisTabularReportRowComponent.prototype.toggleCollapsed = function (event, rowView) {
        if (rowView.children.length) {
            event.stopPropagation();
            var options = this.reportTableView.rows.getCollapsedExpandedOptions().setRowsCount(this.reportTableView.rows.rowsCount)
                .setInfo(this.reportTableView.rows.getRowsInfo());
            if (rowView.collapsed) {
                this.expand(rowView, options);
            }
            else {
                this.collapse(rowView, options);
            }
        }
    };
    SisTabularReportRowComponent.prototype.collapse = function (rowView, options) {
        // toggle row collapsed flags
        rowView.collapsed = true;
        // set flags to collapsed rows
        rowView.collapseRows(options);
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_COLLAPSED, options));
    };
    SisTabularReportRowComponent.prototype.expand = function (rowView, options) {
        // toggle row collapsed flags
        rowView.collapsed = false;
        // set flags to expanded rows
        rowView.expandRows(options);
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_EXPANDED, options));
    };
    SisTabularReportRowComponent.prototype.remove = function (event, rowView, removeSubTree) {
        event.stopPropagation();
        // clean removed element
        this.reportTableView.rows.cleanRemovedElements();
        this.reportTableView.rows.setIndexes();
        // clean previous cycle flags
        this.reportTableView.rows.cleanCreatedRowIndexes();
        var options;
        if (removeSubTree) {
            // get permanent options
            options = this.reportTableView.rows.getCollapsedExpandedOptions()
                .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
            // set removed row flag
            rowView.isRemoved = true;
            options.add(rowView.index, new row_option_1.RowOption(table_row_type_1.TableRowType.REMOVED, true));
            // remove sub-tree
            rowView.removeRows(options);
        }
        else {
            options = this.reportTableView.rows.getCollapsedExpandedOptions();
            var isCollapsed = false;
            if (rowView.collapsed) {
                isCollapsed = true;
                // toggle row collapsed flags
                rowView.collapsed = false;
                // set flags to expanded rows
                rowView.expandRows(options);
            }
            // set removed row flag
            rowView.isRemoved = true;
            // remove row and shift sub-tree
            rowView.removeRow(this.reportTableView.rows, isCollapsed);
            // get table rows options
            options.setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo())
                .add(rowView.index, new row_option_1.RowOption(table_row_type_1.TableRowType.REMOVED, true));
        }
        // set before-removed flag to previous sibling element
        this.reportTableView.rows.setBeforeRemovedFlagOnPreviousSibling(rowView);
        // send event to remove rows from table view
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_REMOVED, options));
        // clean tree after animation done
        this.cleanRemovedRowsAfterAnimationDone();
    };
    SisTabularReportRowComponent.prototype.highlightRemove = function (rowView, removeSubTree) {
        this.reportTableView.rows.cleanHighlightRemoveFlags();
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
        rowView.isGoingToRemove = true;
        options.add(rowView.index, new row_option_1.RowOption(table_row_type_1.TableRowType.HIGHLIGHT_REMOVE, true));
        if (removeSubTree) {
            rowView.setHighlightRemoveFlags(options);
        }
        // send event to highlight current row in table view
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_HIGHLIGHTED, options));
    };
    SisTabularReportRowComponent.prototype.unHighlightRemove = function () {
        this.reportTableView.rows.cleanHighlightRemoveFlags();
        // send event to highlight current row in table view
        var options = this.reportTableView.rows.getCollapsedExpandedOptions()
            .setRowsCount(this.reportTableView.rows.rowsCount).setInfo(this.reportTableView.rows.getRowsInfo());
        this.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_UNHIGHLIGHTED, options));
    };
    /**
     * Method clean removed nodes from tree and redraw rows-tree after animation done.
     * We set timeout for sure animation is done.
     */
    SisTabularReportRowComponent.prototype.cleanRemovedRowsAfterAnimationDone = function () {
        var self = this;
        setTimeout(function () {
            // clean removed element
            self.reportTableView.rows.cleanRemovedElements();
            self.reportTableView.rows.setIndexes();
            // get table rows options
            var options = self.reportTableView.rows.getCollapsedExpandedOptions().setRowsCount(self.reportTableView.rows.rowsCount)
                .setInfo(self.reportTableView.rows.getRowsInfo());
            // send event to highlight current row in table view
            self.viewEventService.rowsChanged(new rows_change_event_1.RowsChangeEvent(rows_change_event_type_1.RowsChangeEventType.ROW_REMOVED, options, true));
        }, 262 * 2);
    };
    SisTabularReportRowComponent.prototype.getRowNumberingSpecifier = function () {
        return SisTabularReportRowComponent_1.ROW_NUMBERING_ENABLED_SPECIFIER;
    };
    var SisTabularReportRowComponent_1;
    SisTabularReportRowComponent.ROW_NUMBERING_ENABLED_SPECIFIER = '#  ';
    __decorate([
        core_1.ViewChild('rowSelectMenu'),
        __metadata("design:type", idm_ng_controls_1.SisSelectComponent)
    ], SisTabularReportRowComponent.prototype, "selectMenu", void 0);
    __decorate([
        core_1.ViewChild('rowReplaceMenu'),
        __metadata("design:type", idm_ng_controls_1.SisSelectComponent)
    ], SisTabularReportRowComponent.prototype, "replaceMenu", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisTabularReportRowComponent.prototype, "rows", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", report_table_view_model_1.ReportTableView)
    ], SisTabularReportRowComponent.prototype, "reportTableView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTabularReportRowComponent.prototype, "dataSetId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", rowview_drag_and_drop_manager_1.RowViewDragAndDropManager)
    ], SisTabularReportRowComponent.prototype, "dndManager", void 0);
    SisTabularReportRowComponent = SisTabularReportRowComponent_1 = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-row',
            template: require('./sis-tabular-report-row.component.html'),
            styles: [require('./sis-tabular-report-row.component.css')],
            encapsulation: core_1.ViewEncapsulation.None,
            changeDetection: core_1.ChangeDetectionStrategy.Default
        }),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService, dataset_container_1.DatasetContainer,
            view_event_service_1.ViewEventService])
    ], SisTabularReportRowComponent);
    return SisTabularReportRowComponent;
}());
exports.SisTabularReportRowComponent = SisTabularReportRowComponent;
//# sourceMappingURL=sis-tabular-report-row.component.js.map